import client from "./client";
import { config } from '../config.js';

const BRIDGE_URL = config.bridge_url;

const getGameUrl = (param: object) => client.post(BRIDGE_URL + "/play", {...param});
const betbyLogin = (param: object) => client.post(BRIDGE_URL + "/betby-login", {...param});
const betbySetting = (param: object) => client.get(BRIDGE_URL + "/betby-setting", {...param});
const pingBoLogin = (param: object) => client.post(BRIDGE_URL + "/ap-gaming-login", {...param});
const getCryptoTradingLogin = (param: object) => client.post(BRIDGE_URL + "/crypto-trading-login", {...param});

const bridgeApi = {
    getGameUrl,
    betbyLogin,
    betbySetting,
    pingBoLogin,
    getCryptoTradingLogin,
};

export default bridgeApi;
